import React, { useState } from 'react';
import BasicModal from '../../atoms/BasicModal';
import { TypableDropdown } from '@HomaHealth/ui-component-library/lib/_AIQ-components';

export interface GroupSelectModalProps {
  open: boolean;
  handleClose: () => void;
  dropdownOptions: string[];
   
  handleSave: (employer_name: string) => void;
  getDefaultRoute: () => void;
}

const GroupSelectModal: React.FC<GroupSelectModalProps> = ({
  open,
  handleClose,
  dropdownOptions,
  handleSave,
  getDefaultRoute,
}) => {
  const [value, setValue] = useState<string>('');
  return (
    <BasicModal
      open={open}
      handleClose={() => {
        getDefaultRoute();
        handleClose();
        setValue('');
      }}
      title={'Select a Group to Continue'}
      saveBtnText="Submit"
      isSaveButton
      saveBtnAction={() => {
        handleSave(value);
        handleClose();
        setValue('');
      }}
    >
      <TypableDropdown
        dropDownOptions={dropdownOptions}
        dropDownValues={dropdownOptions}
        placeholder="Search or select a group..."
        value={value}
        handleChange={(e) => setValue(e.target.value as string)}
        handleInputChange={() => {}}
        searchable
        width="665px"
        height="40px"
      />
    </BasicModal>
  );
};

export default GroupSelectModal;
